var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.32372 16.6405C4.89209 16.1613 4.89209 15.3842 5.32372 14.9049L11.2185 8.35946C11.6501 7.88018 12.3499 7.88018 12.7815 8.35946L18.6763 14.9049C19.1079 15.3842 19.1079 16.1613 18.6763 16.6405C18.2446 17.1198 17.5448 17.1198 17.1132 16.6405L12 10.9629L6.8868 16.6405C6.45517 17.1198 5.75536 17.1198 5.32372 16.6405Z",
    fill: "#1D1D1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.617aca29a0d5c153433785a4e0626c3f.svg";
export { ForwardRef as ReactComponent };